
import { UserPermissionType } from "@apiserver-rest/ponder-auth-client-base";
import { AuthService } from "@ponder-core/auth/auth.service";
import { RoleAndPermissions } from "@ponder-core/auth/role-permissions";
import { getProfileImageRoute } from "@ponder-features/user/profile/profile-image-router";
import { NgClass } from "@angular/common";
import { AdminUnauthorizedComponent } from "./admin-unauthorized.component";
import { Router, RouterOutlet } from "@angular/router";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { Component } from "@angular/core";

@Component({
    imports: [ RouterOutlet, NgClass, AdminUnauthorizedComponent ],
    templateUrl: "./admin-control-panel.component.html"
})
export class AdminControlPanelComponent {
    public isLoading: boolean = true;
    public canView: boolean = false;
    public rolePermissions?: RoleAndPermissions;
    public username?: string;
    public avatarUrl?: string;

    constructor(private authService: AuthService , private route: Router) {

    }

    public ngOnInit(): void {
        this.authService.getSessionAsync().then((authSession?: AuthSession) => {
            this.username = authSession?.username;

            if (this.username) {
                this.avatarUrl = getProfileImageRoute(this.username);
            }

            this.authService
                .getRoleAndPermissions()
                .then((result: RoleAndPermissions | undefined) => {
                    this.rolePermissions = result;
                    this.canView = this.rolePermissions?.hasPermission(UserPermissionType.ViewAdminConsole) ?? false;
                    this.isLoading = false;
                });
        });
    }

    public isViewingAlerts(): boolean {
        return this.route.url.startsWith("/acp/alerts");
    }

    public isViewingNews(): boolean {
        return this.route.url.startsWith("/acp/news");
    }

    public isViewingTasks(): boolean {
        return this.route.url.startsWith("/acp/tasks");
    }

    public isViewingUsers(): boolean {
        return this.route.url.startsWith("/acp/users");
    }

    public isViewingMagic(): boolean {
        return this.route.url.startsWith("/acp/magic");
    }
}